import React from "react";
import { Link } from "react-router-dom";
import motabilityLogo from '../../assets/img/logos/motability-scheme.svg';
import { useBasket } from '../../context/BasketContext';
import axios from 'axios';
import { API_BASE_URL } from '../../constants/api';

const OrderDetails = ({ basket, groupedSlots, formatTime }) => {
    const { addToBasket, clearBasket } = useBasket();

    const handleRemoveSlot = async (bookingId) => {

        // Get bookingIds from storage
        // const bookingIdsStr = localStorage.getItem('bookingIds');
        // if (bookingIdsStr) {
        //     const bookingIds = JSON.parse(bookingIdsStr);
        //     const bookingId = bookingIds.find(booking => booking.slotId === slotId)?.bookingId;

            if (bookingId) {
                // Create form data for cancellation
                const formData = new FormData();
                formData.append('bookings[]', bookingId);
                formData.append('key', '7678356c642c91a255471d162205e0f3');

                // Get ambassador token
                const token = localStorage.getItem('ambassador_token');

                // Call cancel API
                try {

                    await axios.post(`${API_BASE_URL}/api/events/bookings/cancel`, formData, {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': `Bearer ${token}`,
                            'X-Requested-With': 'XMLHttpRequest',
                            'Content-Type': 'multipart/form-data'
                        },
                        withCredentials: true
                    });

                    // Remove booking ID from storage
                    // const updatedBookingIds = bookingIds.filter(booking => booking.slotId !== slotId);

                    // console.log(updatedBookingIds);

                    // localStorage.setItem('bookingIds', JSON.stringify(updatedBookingIds));

                } catch (error) {
                    console.error('Error cancelling booking:', error);
                }
            }
        // }

        console.log(basket.slots);
        
        const updatedSlots = basket.slots.filter(slot => slot.booking_id !== bookingId);

        console.log(updatedSlots);

        if (updatedSlots.length === 0) {


            clearBasket();
        } else {
            addToBasket({
                ...basket,
                slots: updatedSlots
            });
        }
    };

    const isEmpty = !basket?.slots || basket.slots.length === 0;

    return (
        <div className="col-lg-6">
            <div className="bg-motability-mid-black-5 border border-motability-mid-black-2 rounded-4 p-4 p-lg-32">
                <h5 className="text-primary mb-3">
                    Your order
                </h5>

                <div className="order-items">
                    {isEmpty ? (
                        <p className="text-muted mb-0">You have not selected any test drive slots yet.</p>
                    ) : (
                        basket.slots.map((slot, index) => (
                            <div key={slot.id} className="order-item py-3 d-flex align-items-center gap-3">
                                {slot.vehicle?.images_array?.[0] && (
                                    <div className="vehicle-image-container" style={{ width: '120px', flexShrink: 0 }}>
                                        <img 
                                            src={slot.vehicle.images_array[0]} 
                                            alt={slot.vehicle.name}
                                            className="img-fluid rounded-3"
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    </div>
                                )}
                                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3 flex-1">
                                    <div className="d-flex flex-column">
                                        <p className="fw-semibold mb-0">
                                            {basket.event_name && basket.event_name}
                                        </p>
                                        <p className="fw-semibold mb-0">
                                            {slot.vehicle?.name + ' -  ' + slot.vehicle?.number}
                                        </p>
                                        <p className="fw-semibold mb-2">
                                            {new Date(slot.start_at).toLocaleDateString('en-GB', {
                                                weekday: 'long',
                                                day: 'numeric',
                                                month: 'long',
                                                year: 'numeric'
                                            })}
                                        </p>
                                        <div className="d-flex align-items-center mb-0 gap-2">
                                            <p className="mb-0" id="booked-from-date">
                                                <span className="fw-semibold">Time:</span> {formatTime(slot.start_at)}
                                            </p>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger ms-2"
                                                title="Remove slot"
                                                onClick={() => handleRemoveSlot(slot.booking_id)}
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrderDetails; 